import { memo } from "react";

interface Props {
    value: string
}

const TableNumber = ({ value }: Props) => {

    if (!value) {
        value = "";
    }
    value = value.trim();
    if (value.startsWith("-")) {
        value = value.replace("-", "");
        value = `(${value})`;
    }
    const isNegative = value.startsWith("(");

    return isNegative ? <span style={{ color: "#EE4F3A" }}>
        {
            value
        }
    </span> : <span>
        {value}
    </span>

}

export default memo(TableNumber)